import React, { useState, useEffect, useMemo, useCallback } from "react";
import Tabs from "devextreme-react/tabs";
import { isEqual } from "lodash";
import useResources from "../../hooks/useResources";
import { useHistory, useParams } from "react-router";
import { tabs } from "./config";
import { tabNames } from "../../utils/strings";
import { setUIProperty } from "../../redux/slices/uiSlice";
import { useDispatch } from "react-redux";
import { usePrevious } from "../../hooks/usePrevious";

const calculateTabs = (searchData) =>
  tabs.map((tab) => ({
    ...tab,
    badge: searchData[tab.tabName] ? searchData[tab.tabName].length : 0,
  }));

const TradeCaseTabs = () => {
  const { tabName } = useParams();
  const dispatch = useDispatch();

  const selectedIndex = useMemo(() => tabNames.indexOf(tabName), [tabName]);
  const history = useHistory();

  const {
    enquiries,
    quotations,
    purchase_orders,
    order_acknowledgments,
    packing_lists,
    proforma_invoices,
    invoices,
  } = useResources();

  const combinedData = useMemo(
    () => ({
      enquiries,
      quotations,
      purchase_orders,
      order_acknowledgments,
      packing_lists,
      proforma_invoices,
      invoices,
    }),
    [
      enquiries,
      quotations,
      purchase_orders,
      order_acknowledgments,
      packing_lists,
      proforma_invoices,
      invoices,
    ]
  );

  const prevData = usePrevious(combinedData);

  const [tabsWithBadge, setTabsWithBadge] = useState([]);

  // TODO: must find a way to recalculate tabs badges without changing the whole tab
  useEffect(() => {
    if (isEqual(prevData, combinedData)) return;
    setTabsWithBadge(calculateTabs(combinedData));
  }, [combinedData, prevData]);

  const onTabsSelectionChanged = useCallback(
    (args) => {
      if (args.name === "selectedIndex" && args.value >= 0) {
        dispatch(setUIProperty({ name: "page", value: 1 }));

        history.push(`/admin/results/${tabNames[args.value] || tabNames[0]}`);
      }
    },
    [dispatch, history]
  );

  return (
    <div>
      <Tabs
        dataSource={tabsWithBadge}
        selectedIndex={parseInt(selectedIndex)}
        onOptionChanged={onTabsSelectionChanged}
      />
      {tabs[selectedIndex >= 0 ? selectedIndex : 0].content}
    </div>
  );
};

export default TradeCaseTabs;
